import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'
import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoCreationSelector = state => state.interactiveVideoCreation
const mcqActivitySelector = state => state.creationTool.mcq

const mcqContainerSelector = createSelector(
	[
		interactiveVideoCreationSelector,
		mcqActivitySelector,
		userCredentialsSelector,
	],
	(
		interactiveVideoCreationData,
		mcqData,
		userCredentials,
	) => {
		const question = mcqData.question

		const answerError = answer => !answer.media.payload.text && !answer.textTouched
		const questionError = !question.text && !question.textTouched
		const noCorrectAnswerError = question.answers.filter(answer => answer.correct).length === 0
			&& !question.touched

		const answersWithErrors = question.answers
			.findIndex(answer => answerError(answer) === true) !== -1

		const formattedQuestion = {
			...question,
			textErrors: questionError ? localize('creationTool_question_missingQuestionText') : '',
			noCorrectAnswerError: noCorrectAnswerError ? localize('creationTool_question_missingCorrectAnswer') : '',
			id: mcqData.activityUid, // Added just to mantain compatibility with question component
			answers: question.answers.map(answer => ({
				...answer,
				textErrors: answerError(answer) ? localize('creationTool_question_missingAnswerText') : '',
				id: answer.clientId, // Added just to mantain compatibility with question component
			})),
			hasErrors:
				questionError
				|| answersWithErrors
				|| noCorrectAnswerError,
		}

		return {
			jwt: userCredentials.interactiveVideo,
			question: formattedQuestion,
			isModified: mcqData.isModified,
			isEdition: interactiveVideoCreationData.currentActivity.isEdition,
		}
	}
)

export default mcqContainerSelector
